import EmptyState from "../../components/shared/EmptyState";
import ErrorState from "../../components/shared/ErrorState";
import LoadingState from "../../components/shared/LoadingState";
import { usePublishedSchedules } from "../../hooks/usePublishedSchedules";
import { Container } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";

/**
 * Wejście w harmonogram: redirect do jednego dnia, listy dni lub pusty stan.
 */
export default function ScheduleGate() {
  const { competitionId } = useParams<{ competitionId: string }>();
  const { schedules, loading, error, refreshSchedules } = usePublishedSchedules(competitionId);

  if (!competitionId) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <EmptyState message="Nieprawidłowy adres turnieju." />
      </Container>
    );
  }

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LoadingState message="Ładowanie harmonogramu..." />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <ErrorState message={error} onRetry={refreshSchedules} />
      </Container>
    );
  }

  if (schedules.length === 0) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <EmptyState message="Brak opublikowanego harmonogramu." />
      </Container>
    );
  }

  if (schedules.length === 1) {
    return <Navigate to={`/${competitionId}/schedule/${schedules[0].id}`} replace />;
  }

  return <Navigate to={`/${competitionId}/schedule-list`} replace />;
}
